import { useQuery } from "@tanstack/react-query";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { areaApiGet } from "../../../../API/areaApi/areaApi";
import {
  customerApiPost,
} from "../../../../API/customerApi/customerApi";
import { ConvertEnglish } from "../../../../components/ConterEnglsih";
import { GStore } from "../../../../context/Context";
import CustomerModal from "../CustomerModal/CustomerModal";
import {
  FaEllipsisH,
  FaEquals,
  FaGripLines,
  FaGripVertical,
  FaLayerGroup,
  FaList,
  FaTable,
} from "react-icons/fa";
import { format } from "date-fns";
import CustomerGeneralModal from "../CustomerModal/CustomerGeneralModal";
import { FETCHING_ERROR, FETCHING_OF, FETCHING_START, FETCHING_SUCCESS_ARES, FETCHING_SUCCESS_CUSTOMER } from "../../../../state/actionTypes/actionTypes";
import axios from 'axios';
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../../../sheard/LoadingPage";
import { webTittle } from "../../../sheard/webTittle";


const Customer = () => {
  webTittle("গ্রাহক")
  const [close, setClose] = useState(true);
  const { register, handleSubmit, reset } = useForm();
  const [dateSelected, setDateSelected] = useState(new Date());
  const [grid, setGrid] = useState(true);
  const [customerGeneralModalInfo, setCustomerGeneralModalInfo] = useState({});
  const [search,setSearch] = useState({});
  const [searchCustomers,setSearchCustomers] =useState([]);
  const todayDate = new Date();
  const todayFormatDate = format(todayDate, "PP");
  const { english, state ,dispatch } = useContext(GStore);
  const [area, setArea] = useState(null);
  const customerAddDate = format(dateSelected, "PP");
  const [payAmount, setPayAmount] = useState(null);
  const navigation = useNavigate();
  // console.log(search);

  useEffect(()=>{
    let searchResult = state.customers.filter(customer =>parseInt(customer.customerId) === parseInt(search))
    if(!searchResult.length > 0){
      searchResult = state.customers.filter(customer => customer?.customerArea?.slice(0,5) === area?.slice(0,5))
    }
    if(!searchResult.length > 0){
      searchResult = state.customers.filter(customer => !customer.customerName.search(search))
      if(!searchResult.length > 0){
        searchResult = state.customers.filter(customer => !customer.customerNumber.search(search))
        if(!searchResult.length > 0){
          searchResult = state.customers.filter(customer => !customer.house.search(search))
        }
      }
    }
    // console.log(searchResult);
     setSearchCustomers(searchResult) 
  },[search,area])
  // console.log(state);
  
  const {areas : areasData, customers : customerData ,loading} = state;


  let showCustomer = [];
// console.log(searchCustomers);
 

    if(searchCustomers.length > 0) {
      showCustomer.push(...searchCustomers)
    }
   
    // console.log(area)
   if(area === "All Customer" || area === null){
        showCustomer = state?.customers
    }

  // console.log(format(dateSelected, "PP").split(",")[0].split(" ")[1]);

   

  const handleAddCustomer = (data) => {
    const customerIdAlreadyHave = state?.customers.find(customer => customer.customerId === data.customerId)
    if(customerIdAlreadyHave){
      return toast.error("এই আইডি আগে থেকেই আছে") ;
    }
    // console.log(customerIdAlreadyHave)
    dispatch({type : FETCHING_SUCCESS_CUSTOMER, payload : [...state.customers,data]});
    const withDateInfo = { ...data, customerAddDate,adminNumber : state.adminNumber};
    customerApiPost(withDateInfo);
    reset();
    setClose(false);
  };
  const handleSelect = (e) => {
    // console.log(e.target.value);
    const newArea = e.target.value;
    setArea(newArea);
  };
 

  const handlePaymentRequest = (id) => {
    if(customerGeneralModalInfo.stupidity < payAmount || payAmount === null) {
      return toast.error(`গ্রাহকের পাওনা টাকা ${customerGeneralModalInfo.stupidity} থেকে বেশি দিয়ে ফেলেছেন ${payAmount}`)
    }
    const payment = {
     paymentDate: todayFormatDate,
      payAmount,
    };
    dispatch({type : FETCHING_START})
    axios.put(`https://amar-dish-server.vercel.app/customer/${id}?collectorNumber=${state?.user?.userNumber}`,payment).then(res =>{
      // console.log(res.data);
      if(res.data.modifiedCount > 0){
        toast.success(`পরিশোধ সফল হয়েছে`)
        navigation(`/payments/${id}`)
      }
      dispatch({type : FETCHING_OF})
    }).catch(err =>{
      dispatch({type : FETCHING_ERROR})
    })

    // console.log(payment);
  };

  return (
    <div className="mx-2">
      <div className="flex justify-between items-center m-5">
        <h2 className="text-3xl font-bold ">
          <ConvertEnglish english={"Customer"} bangla={"গ্রাহক"} />
        </h2>
        <p className="text-2xl font-bold ">{todayFormatDate}</p>
      </div>
      <div className="flex justify-center items-center">
        <select
          onChange={handleSelect}
          className="select select-bordered w-[50%]"
        >
          <option defaultChecked value="All Customer">
            <ConvertEnglish english={"All Customer"} bangla={"সকল গ্রাহক"} />
          </option>
          {areasData &&
            areasData.map((areaData) => (
              <option key={areaData._id} value={areaData.area}>
                {areaData.area}
              </option>
            ))}
        </select>

        <label
          onClick={() => {
            setClose(true);
          }}
          htmlFor="add-customer-modal"
          className="btn btn-outline text-1xl m-5 font-bold "
        >
          <ConvertEnglish english={"Add customers"} bangla={"গ্রাহক সংযোগ"} />
        </label>
      </div>
      <div className="flex items-center px-4 lg:px-10 border-b shadow-md p-2">
        <div className=" flex-1 justify-center items-center">
          <input
            type="text"
            onChange={(e)=>setSearch( e.target.value)}
            placeholder={english ? "Find customer ..." : "গ্রাহক খুঁজুন ..."}
            className="input my-5 w-[99%] input-bordered  "
          />
        </div>
        <div className="flex items-center">
          <button onClick={() => setGrid(!grid)} className="btn btn-ghost ">
            {grid ? (
              <FaGripLines size={24}></FaGripLines>
            ) : (
              <FaGripVertical size={24}></FaGripVertical>
            )}
          </button>
        </div>
      </div>
      {
        loading ?<LoadingPage></LoadingPage> : <div>
        {grid ? (
          <>
            <div className="h-[700px] w-full overflow-y-scroll">
              {showCustomer.length > 0 ?
                showCustomer?.map((customer, i) => (
                  <div key={customer.customerId}>
                    <div
                   
                      className="my-3 p-2 flex items-center gap-3 shadow-md"
                    >
                      <h1 className="text-3xl w-20 h-20 flex items-center justify-center bg-blue-500 rounded-full p-4 text-white">
                        {customer?.customerName?.slice(0, 1)}
                      </h1>
                      <div className="flex-1">
                        <h2 className="font-bold">
                          আইডি : {customer?.customerId}
                        </h2>
                        <h2 className="font-bold">
                          গ্রাকের নাম {customer.customerName}
                        </h2>
                        <h2>
                          মাসিক ফি :{" "}
                          <span className="font-black">
                            {customer.monthlyFee}
                          </span>
                        </h2>
                        <h2>
                          বকেয়া :{" "}
                          <span className="font-black">
                            {customer.stupidity}{" "}
                          </span>{" "}
                        </h2>
                      </div>
                      <div className="flex justify-end relative">
                        <div className="dropdown dropdown-left items-center">
                          <label
                            tabIndex={0}
                            className="btn btn-ghost btn-circle avatar"
                          >
                            <FaEllipsisH size={30}></FaEllipsisH>
                          </label>
                          <ul
                            tabIndex={0}
                            className=" py-2 font-semibold shadow menu menu-compact  dropdown-content items-center justify-center  bg-base-100 rounded-box w-40"
                          >
                            <li className="">
                              <a className="btn btn-ghost ">
                                <label
                                  onClick={() =>
                                    setCustomerGeneralModalInfo(customer)
                                  }
                                  htmlFor="customerGeneralModal"
                                  className="py-1"
                                >
                                  বিল সংগ্রহ
                                </label>
                              </a>
                            </li>
                            <li className="py-1 text-center  ">
                              <a className="btn btn-ghost ">গ্রাহকের তথ্য</a>
                            </li>
                            <li className=" ">
                              <a className="btn btn-ghost "> তথ্য পরিবর্তণ</a>
                            </li>
                            <li className=" ">
                              <a className="btn btn-ghost ">আরো আসবে</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
                : <><h2 className="text-2xl text-gray-600 mt-5 text-center">কোন গ্রাহক পাওয়া যাইনি , নতুন গ্রাহক সংযোগ করুন</h2></>
                } :
            </div>
          </>
        ) : (
          <>
            <table className="table table-compact w-full">
              {/* <!-- head --> */}
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <ConvertEnglish
                      english={"Customer Name"}
                      bangla={"গ্রাহকের নাম"}
                    />
                  </th>
                  <th>
                    <ConvertEnglish
                      english={"MonthlyFee"}
                      bangla={"মাসিক ফি"}
                    />
                    <br />
                    <ConvertEnglish english={"stupidity"} bangla={"বকেয়া"} />
                  </th>
                  <th>
                    <ConvertEnglish english={"Address"} bangla={"ঠিকানা"} />
                  </th>
                  <th>
                    <ConvertEnglish english={"options"} bangla={"আর"} />
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* <!-- row 1 --> start*/}
                {showCustomer &&
                  showCustomer.map((customer, i) => (
                    <tr key={customer.i} className="border-b">
                      <td>{i + 1}</td>
                      <td>
                        <p className="">{customer.customerName}</p>
                      </td>
                      <td>
                        <span className="flex gap-3">
                          <ConvertEnglish
                            english={"MonthlyFee"}
                            bangla={"মাসিক ফি"}
                          />{" "}
                          :
                          <p className="font-black text-blue-700">
                            {customer.monthlyFee}
                          </p>
                        </span>
                        <br />
                        <span className="flex gap-3">
                          <ConvertEnglish
                            english={"stupidity"}
                            bangla={" বকেয়া"}
                          />{" "}
                          :
                          <p
                            className={
                              customer.stupidity > 600
                                ? "font-black text-red-700"
                                : "font-black text-green-700"
                            }
                          >
                            {customer.stupidity}
                          </p>
                        </span>
                      </td>
                      <td className="hidden lg:block">
                        {customer.holding} {customer.house} {customer.floor}
                      </td>
                      <td>
                        <div className="dropdown dropdown-left">
                          <label tabIndex={0} className="cursor-pointer m-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              className="inline-block w-5 h-5 stroke-current"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                              ></path>
                            </svg>
                          </label>
                          <ul
                            tabIndex={0}
                            className="dropdown-content menu p-2 shadow bg-base-100 rounded-box "
                          >
                            <li>
                              <a className="btn btn-ghost ">Item 1</a>
                            </li>
                            <li>
                              <a className="btn btn-ghost ">Item 2</a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  ))}

                {/* <!-- row 1 --> end*/}
              </tbody>
            </table>
          </>
        )}
      </div>
      }
      {close && (
        <CustomerModal
          setClose={setClose}
          dateSelected={dateSelected}
          setDateSelected={setDateSelected}
          areasData={areasData}
          handleAddCustomer={handleAddCustomer}
          register={register}
          handleSubmit={handleSubmit}
        ></CustomerModal>
      )}
      {
        <CustomerGeneralModal
        loading={loading}
          setPayAmount={setPayAmount}
          handlePaymentRequest={handlePaymentRequest}
          title={"বিল পরিশোধ"}
          customerGeneralModalInfo={customerGeneralModalInfo}
        ></CustomerGeneralModal>
      }
    </div>
  );
};

export default Customer;
